<template>
    <div class="app-container goods-record-detail">
    <basic-container v-loading="loading">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本资料" name="detail">
          <el-divider content-position="right"></el-divider>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">商品预览:</el-col>
            <el-col :span="16">
              <div class="goods-preview">
                <div class="goods-cover-image" v-if="goodsRecordDetail.coverImg" v-viewer>
                  <img :src="goodsRecordDetail.coverImg">
                </div>
                <a href="javascript:void(0);" @click="toGoodsDetail(goodsRecordDetail.goodsId);"
                    class="goods-record-detail-href">
                  {{goodsRecordDetail.goodsName}}
                </a>
              </div>
            </el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">核销类型:</el-col>
            <el-col :span="16">{{goodsRecordDetail.redeemType.label}}</el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">花费积分:</el-col>
            <el-col :span="16">{{goodsRecordDetail.rewardValue}}</el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">兑换人昵称:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toMemberDetail(goodsRecordDetail.memberId);" class="goods-record-detail-href">
                {{goodsRecordDetail.memberInfo.nickname | formatDefaultVal}}
              </a>
            </el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">兑换人姓名:</el-col>
            <el-col :span="16">{{goodsRecordDetail.memberInfo.realname | formatDefaultVal}}</el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">兑换人员工编号:</el-col>
            <el-col :span="16">{{goodsRecordDetail.memberInfo.unionId | formatDefaultVal}}</el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">下单时间:</el-col>
            <el-col :span="16">{{goodsRecordDetail.insertedTime}}</el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">状态:</el-col>
            <el-col :span="16">{{goodsRecordDetail.status.label}}</el-col>
          </el-row>
          <el-row class="goods-record-detail-item">
            <el-col :span="3">状态备注:</el-col>
            <el-col :span="16">{{goodsRecordDetail.statusComment | formatDefaultVal}}</el-col>
          </el-row>
          <div v-if="isDisplayConsigneeAndCourier()">
            <div v-if="goodsRecordDetail.memberConsigneeInfo.name">
              <el-row class="goods-record-detail-item">
                <el-col :span="3">收货人姓名:</el-col>
                <el-col :span="16">{{goodsRecordDetail.memberConsigneeInfo.name}}</el-col>
              </el-row>
              <el-row class="goods-record-detail-item">
                <el-col :span="3">手机号:</el-col>
                <el-col :span="16">{{goodsRecordDetail.memberConsigneeInfo.phoneNumber}}</el-col>
              </el-row>
              <el-row class="goods-record-detail-item">
                <el-col :span="3">收货地址:</el-col>
                <el-col :span="16">{{goodsRecordDetail.memberConsigneeInfo.address}}</el-col>
              </el-row>
            </div>
            <el-row class="goods-record-detail-item" v-else>
              <el-col :span="3">收货人信息:</el-col>
              <el-col :span="16">用户未填写</el-col>
            </el-row>
            <el-row class="goods-record-detail-item" v-if="goodsRecordDetail.courierCompany">
              <el-col :span="3">快递公司:</el-col>
              <el-col :span="16">{{goodsRecordDetail.courierCompany}}</el-col>
            </el-row>
            <el-row class="goods-record-detail-item">
              <el-col :span="3" v-if="goodsRecordDetail.courierNumber">快递单号:</el-col>
              <el-col :span="3" v-else>快递信息:</el-col>
              <el-col :span="6" v-if="goodsRecordDetail.courierNumber">{{goodsRecordDetail.courierNumber}}</el-col>
              <el-col :span="2" v-else>未录入</el-col>
              <el-col :span="3" v-if="permissions.courier_info_entry">
                <el-tooltip placement="top" :content="getToolTipContent()" :disabled="isDisabledToolTip()">
                  <div>
                    <el-button
                      size="mini"
                      type="primary"
                      :disabled="!isDisabledToolTip()"
                      @click="entryCourierInfo"
                      >{{ goodsRecordDetail.courierNumber ? '点击修改快递信息' : '点击录入快递信息' }}
                    </el-button>
                  </div>
                </el-tooltip>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-button round @click="handleBack">返回</el-button>
    </basic-container>
    <el-dialog
      :visible.sync="entryCourierInfoDialog"
      @close="closeEntryCourierInfoDialog"
      :close-on-click-modal="false"
      width="30%"
      class="handle-dialog">
        <el-form ref="entryCourierInfoFrom" :model="entryCourierInfoFrom" :rules="rules">
            <el-form-item prop="courierCompany">
              <el-label >快递公司:</el-label>
              <el-input type="text" placeholder="请输入快递公司名称名称" v-model="entryCourierInfoFrom.courierCompany" clearable></el-input>
            </el-form-item>
            <el-form-item prop="courierNumber">
              <el-label >快递单号:</el-label>
              <el-input type="text" placeholder="请输入快递单号" v-model="entryCourierInfoFrom.courierNumber" clearable></el-input>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button class="handle-dialog-footer-cancel" @click="closeEntryCourierInfoDialog">取消</el-button>
              <el-button type="primary" class="handle-dialog-footer-save" @click="handleEntryCourierInfo">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getMemberGoodsRecordDetail, entryCourierInfo } from '@/api/mall/record';
import { memberGoodsStatusOptions } from '@/const/crud/mall/record';
import { redeemTypeOptions } from '@/const/crud/mall/goods';
import { goodsRedeemTypesEnum, memberGoodsStatusEnum } from '@/common/enums/mallTypeEnum';

export default {
  data() {
    return {
      id: null,
      activeName: "detail",
      loading: false,
      goodsRecordDetail: {},
      entryCourierInfoDialog: false,
      entryCourierInfoFrom: {
        id: null,
        courierCompany: '',
        courierNumber: '',
      },
      rules: {
        courierCompany: [
          { required: true, message: '快递公司不能为空', trigger: 'blur' },
          { max: 50, message: '长度不超过 50 个字符', trigger: 'blur' }
        ],
        courierNumber: [
          { required: true, message: '快递单号不能为空', trigger: 'blur' },
          { max: 50, message: '长度不超过 50 个字符', trigger: 'blur' }
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  filters: {
    formatDefaultVal(val) {
      return val ? val : '--';
    },
  },
  async mounted() {
    await this.initDetail(this.$route.params.id)
  },
  methods: {
    async initDetail(id) {
      const response = await getMemberGoodsRecordDetail(id);
      if (response.status == 200) {
        this.formatGoodsDetail(response.data.data);
      } else {
        this.$message({
          showClose: true,
          message: '无法查看用户兑换详情',
          type: 'error'
        });
      }
    },
    formatGoodsDetail(data) {
      this.id = data.id;
      data.redeemType = redeemTypeOptions.find(item => item.value === data.redeemType) || { label: '其他', value: -1 };
      data.memberConsigneeInfo = data.memberConsigneeInfo || {};
      data.status = memberGoodsStatusOptions.find(item => item.value == data.status) || { label: '其他', value: -1 };
      this.goodsRecordDetail = data;
    },
    entryCourierInfo() {
      this.entryCourierInfoFrom.id = this.goodsRecordDetail.id;
      this.entryCourierInfoFrom.courierCompany = this.goodsRecordDetail.courierCompany || '';
      this.entryCourierInfoFrom.courierNumber = this.goodsRecordDetail.courierNumber || '';
      this.entryCourierInfoDialog = true;
    },
    handleEntryCourierInfo() {
      this.$refs.entryCourierInfoFrom.validate((valid) => {
        if (!valid) return
        entryCourierInfo(this.entryCourierInfoFrom).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.entryCourierInfoDialog = false;
          this.initDetail(this.id);
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    closeEntryCourierInfoDialog() {
      this.$refs.entryCourierInfoFrom.clearValidate();
      this.entryCourierInfoDialog = false;
      this.entryCourierInfoFrom.id = null;
      this.entryCourierInfoFrom.courierCompany = '';
      this.entryCourierInfoFrom.courierNumber = '';
    },
    toGoodsDetail(id) {
      if (id){
        this.$router.push({
          path: `/mall/goods/detail/${id}`
        })
      } else {
        this.$message({
          showClose: true,
          message: '该商品不存在',
          type: 'warning'
        })
      }
    },
    toMemberDetail(id) {
      if (id){
        this.$router.push({
          path: `/upms/member/detail/${id}`,
        })
      } else {
        this.$message({
          showClose: true,
          message: '用户不存在',
          type: 'warning'
        })
      }
    },
    handleBack() {
      this.$router.back();
    },
    isDisplayConsigneeAndCourier() {
      return this.goodsRecordDetail.redeemType.value === goodsRedeemTypesEnum.PHYSICAL_EXCHANGE.code
    },
    getToolTipContent() {
      if (this.goodsRecordDetail.status.value === memberGoodsStatusEnum.HAS_CHANGED.code || this.goodsRecordDetail.status.value === memberGoodsStatusEnum.LOCKED.code) {
        return '用户尚未填写收货人信息';
      } else if (this.goodsRecordDetail.status.value === memberGoodsStatusEnum.CONFIRM_RECEIPT.code) {
        return '用户已确认收货';
      } else {
        return '暂无提示';
      }
    },
    isDisabledToolTip() {
      return this.goodsRecordDetail.redeemType.value === goodsRedeemTypesEnum.PHYSICAL_EXCHANGE.code &&
             (this.goodsRecordDetail.status.value === memberGoodsStatusEnum.NO_DELIVERED.code || this.goodsRecordDetail.status.value === memberGoodsStatusEnum.DELIVERED.code);
    },
  },
}
</script>

<style  lang="scss" scoped>
.goods-record-detail {
  &-item {
    font-size: 16px;
    margin: 10px 0;
  }
}
.goods-preview {
  display: flex;
  align-items: center;
  .goods-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
.goods-record-detail-href {
    color: #409EFF;
    font-size: 14px;
}
.handle-dialog {
  display: flex;
  flex-direction: column;
  &-footer{
    display: flex;
    flex-direction: row;
    padding: 50px 0px;
    &-cancel {
      padding: 8px 12px;
      position: absolute;
      right: 90px;
    }
    &-save {
      padding: 8px 12px;
      position: absolute;
      right: 10px;
      margin-right: 10px;
    }
  }
}
</style>
